import { createStore } from 'vuex';
import modules from './modules/';

export default createStore({
  modules,
  state: {
    isReportModal: false,
    jobId: 0,
  },

  getters: {
    isReportModal: state => state.isReportModal,
    jobId: state => state.jobId,
  },
  mutations: {
    toggle(state) {
      state.isReportModal = !state.isReportModal;
    },
    changeJobId(state, id) {
      state.jobId = id;
    },
  },
  actions: {
    changeJobId(context, id) {
      context.commit('changeJobId', id);
    },
    toggle(context) {
      context.commit('toggle');
    },
  },
});
